import {Component, Vue} from "vue-property-decorator";
import {formatDate} from '@/utils/timeFilter'
import {menuBtn} from '@/utils/menu_level2_button'
import {
    addClasses,
    getClasses,
    getStudentById,
    setStudentByclasserId,
    setStudentToNewClasserId
} from "@/api/classManage";
import {delNullProperty} from "@/utils";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

@Component({
    components:{
        MoreUsersFilter
    }
})
export default class ClassesStudentInfo extends Vue {
    // ------ 变量 ------
    studentInfo: any = {}
    operationShow = true
    activities = []
    studentId = ''
    isShow = '' // 编辑为1 ，详情为0
    formData = {
        classRatio: '1',
        name: '',
        code: '',
        teacherUserId: '',
        thesisUserId: '',
        helperUserId: '',
        applyUserId: '',
    }
    formRules = {
        classRatio: [{required: true, message: '请选择班级', trigger: ['blur', 'change']}],
        name: [{required: true, message: '请填写班级名称', trigger: ['blur', 'change']}],
    }
    projectAllId = null
    classesId = null
    alreadyClassId = null
    classesList = []
    page = 1
    pageSize = 20
    total = 0
    isTurnClass = ''
    isClasses = ''
    query = ''
    name = ''
    alreadyClassName = ''
    disabledBtn = false

    buttonShow(id: number): boolean {
        return menuBtn(id)
    }

    formatDate(format: string, val: Date) {
        return formatDate(format, new Date(val))
    }

    created() {
        this.studentId = String(this.$route.query.id)
        this.isShow = String(this.$route.query.isShow)
        this.isTurnClass = String(this.$route.query.isTurnClass)
        this.getInfo()
    }


    async getInfo() {
        await getStudentById(this.studentId).then((res: any) => {
            this.studentInfo = res.student
            this.projectAllId = res.student.projectAllId
            this.classesId = res.student.classesId // 调班
            this.isClasses = res.student.isClasses
            this.activities = res.student.studentLogList
        })

    }

// 调班
    handleTurnClass() {
        this.isShow = '1' //变成可编辑状态
    }

//  入班
    handleEnterClass() {
        this.isShow = '1'
    }

    doConfirmClass() {
        this.isClasses == '已入班' ? this.doConfirmTurnClass() : this.doConfirmEnterClass()
    }

    doCancel() {
        window.close()
    }

//  入班
    async doConfirmEnterClass() {
        if (this.formData.classRatio == '1') {// 新建
            let flag = true;
            (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
                if (!valid) {
                    flag = false
                    return
                }
            })
            const obj = {
                name: this.formData.name,
                code: this.formData.code,
                teacherUserId: this.formData.teacherUserId,
                thesisUserId: this.formData.thesisUserId,
                helperUserId: this.formData.helperUserId,
                applyUserId: this.formData.applyUserId,
                projectAllId: this.projectAllId
            }
            if (flag) {
                this.disabledBtn = true
                const data: any = await addClasses(delNullProperty(obj))
                await setStudentByclasserId(data.id, {idList: [this.studentId]})
                this.$message.success('入班成功')
                // this.disabledBtn = false
                setTimeout(() => {
                    window.close()
                }, 1500)
            }
        } else if (this.formData.classRatio == '2') { // 选择已有的
            if (!this.alreadyClassId) {
                this.$message.error('请选择已有班级')
                return;
            }
            this.disabledBtn = true
            await setStudentByclasserId(this.alreadyClassId, {idList: [this.studentId]})
            this.$message.success('入班成功')
            // this.disabledBtn = false
            setTimeout(() => {
                window.close()
            }, 1500)
        }
    }


    /*
    * 调班*/

    async doConfirmTurnClass() {
        if (this.formData.classRatio == '1') {// 新建
            let flag = true;
            (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
                if (!valid) {
                    flag = false
                    return
                }
            })
            const obj = {
                name: this.formData.name,
                code: this.formData.code,
                teacherUserId: this.formData.teacherUserId,
                thesisUserId: this.formData.thesisUserId,
                helperUserId: this.formData.helperUserId,
                applyUserId: this.formData.applyUserId,
                projectAllId: this.projectAllId
            }
            if (flag) {
                this.disabledBtn = true
                const data: any = await addClasses(delNullProperty(obj))
                await setStudentToNewClasserId(this.classesId, data.id, {idList: [this.studentId]})
                this.$message.success('调班成功')
                // this.disabledBtn = false
                setTimeout(() => {
                    window.close()
                }, 1500)
            }
        } else if (this.formData.classRatio == '2') { // 选择已有的
            if (!this.alreadyClassId) {
                this.$message.error('请选择已有班级')
                return;
            }
            this.disabledBtn = true
            await setStudentToNewClasserId(this.classesId, this.alreadyClassId, {idList: [this.studentId]})
            this.$message.success('调班成功')
            // this.disabledBtn = false
            setTimeout(() => {
                window.close()
            }, 1500)
        }
    }


    async getClassList() {
        const data: any = await getClasses(delNullProperty({
            limit: this.pageSize,
            name: this.name,
            projectAllId: this.projectAllId
        }))
        this.classesList = [...this.classesList, ...data.classesList]
        const result = []
        const obj = {}
        for (let i = 0; i < this.classesList.length; i++) {
            if (!obj[this.classesList[i].id]) {
                result.push(this.classesList[i]);
                obj[this.classesList[i].id] = true;
            }
        }
        this.classesList = result
        if (this.classesList.length == 0) {
            this.$message.error('该项目下暂无班级，请去新建')
        }
    }

    loadmore() {
        this.pageSize += 20;
        this.getClassList();
    }

    async getFoucsClassList() {
        if (this.classesList.length == 0 && !this.alreadyClassName) {
            this.name = ''
            this.pageSize = 20
            const result: any = await getClasses(delNullProperty(
                {
                    limit: this.pageSize,
                    name: this.name,
                    projectAllId: this.projectAllId
                }
            ))
            this.classesList = result.classesList
            if (this.classesList.length == 0) {
                this.$message.error('该项目下暂无班级，请去新建')
            }
        }
        if (this.alreadyClassName) {
            this.classesList = []
            this.pageSize = 20
            const result: any = await getClasses({
                limit: this.pageSize,
                name: this.alreadyClassName,
                projectAllId: this.projectAllId
            })
            this.classesList = result.classesList
            if (this.classesList.length == 0) {
                this.$message.error('该项目下暂无班级，请去新建')
            }
        }
    }

    clearClassList() {
        if (!this.alreadyClassName) {
            this.name = ''
            this.pageSize = 20
            this.getClassList()
        }
    }

    async remoteMethod(query: any) {
        this.name = query
        this.pageSize = 20
        if (query !== '') {
            const result: any = await getClasses({
                limit: this.pageSize,
                name: this.name,
                projectAllId: this.projectAllId
            })
            this.classesList = result.classesList
            if (this.classesList.length == 0) {
                this.$message.error('该项目下暂无班级，请去新建')
            }
        } else {
            this.classesList = []
            this.getClassList();
        }
    }

    changeAlreadyClass(val) {
        this.alreadyClassId = val
    }

    changeTeacherUser(e) {
        this.formData.teacherUserId = e.id
    }

    changeThesisUser(e) {
        this.formData.thesisUserId = e.id
    }

    changeHelperUser(e) {
        this.formData.helperUserId = e.id
    }
    changeApplyUserId(e) {
        this.formData.applyUserId = e.id
    }
}
